<div class="container-fluid py-4">
  <div class="row mb-4 justify-content-center">
    <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- <div
        [class]="i < 3 ? 'col-md-4' : 'col-md-3'"
        *ngFor="let card of resumenCards; index as i"
      > -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route || i === 0 || 1 ? 'pointer' : 'default'"
      >
        <!-- (click)="i === 0 ? getInternal() : null" 
           (click)="handleCardClick(i)"-->
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow icon-card"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/registry']"
        >
          Registry
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/qaRun']"
        >
          QA Run
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/internalLinks']"
        >
          Internal Links
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageDashboard']"
        >
          On-P Insights
        </a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing']"
        >
          Keywords
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageRecommendations']"
        >
          Off-P Recomm
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageProspects']"
        >
          Off-P Prospects
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageBacklinks']"
        >
          Off-P Backlinks
        </a>
      </div>

      <!-- <div style="width: 40px"></div> -->
    </div>
  </div>
  <!-- Campo de búsqueda mejorado con autocompletado -->
  <div class="row mb-3">
    <div class="col-md-4">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search ..."
          [(ngModel)]="searchText"
          (ngModelChange)="filterInfo()"
          list="suggestions"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent"
          ><i class="fas fa-search text-dark"></i
        ></span>
        <datalist id="suggestions">
          <option
            *ngFor="let sugerencia of sugerenciasBusqueda"
            [value]="sugerencia"
          ></option>
        </datalist>
      </div>
    </div>
  </div>

  <!--Volumen  -->

  <div class="row d-flex">
    <div class="col-4 d-flex">
      <div class="card shadow-sm h-90">
        <div class="card-body p-0">
          <div class="table-responsive">
            <h3 class="text-center"><strong>Volumen</strong></h3>
            <table class="table table-bordered table-striped">
              <thead class="thead">
                <tr>
                  <th>Keyword</th>
                  <th>Volumen de busqueda</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Marketing digital</td>
                  <td>90.500</td>
                  <td>Alta</td>
                </tr>
                <tr>
                  <td>SEO</td>
                  <td>90.500</td>
                  <td>Alta</td>
                </tr>
                <tr>
                  <td>Contenido</td>
                  <td>2.400</td>
                  <td>Baja</td>
                </tr>
                <tr>
                  <td>Inbound marketing</td>
                  <td>7.000</td>
                  <td>Alta</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- articulos  -->

    <div class="col-4 d-flex">
      <div class="card shadow-sm h-90">
        <div class="card-body p-0">
          <div class="table-responsive">
            <h3 class="text-center"><strong>Artículos</strong></h3>
            <table class="table table-bordered table-striped">
              <thead class="thead">
                <tr>
                  <th>
                    <img
                      class="img"
                      src="../../../assets/img/logoCompany.jpeg"
                      alt=""
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                <h4 class="padding">
                  <strong>Estrategias de marketing digital</strong>
                </h4>

                <p class="padding">
                  En el competitivo mundo del marketing digital, es esencial
                  implementar estrategias sólidas
                </p>

                <button class="btn btn-dark btn-sm ml-2 btn">
                  Aprobar y publicar
                </button>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- ranking -->

    <div class="col-4 d-flex">
      <div class="card shadow-sm h-90">
        <div class="card-body p-0">
          <div class="table-responsive">
            <h3 class="text-center"><strong>Ranking</strong></h3>
            <table class="table table-bordered table-striped">
              <thead class="thead">
                <tr>
                  <th>Keyword</th>
                  <th>Ranking</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="d-grid">
                    Marketing digital
                    <p>www.example.com/marketing</p>
                  </td>
                  <td>3 <i class="fa-solid fa-arrow-up"></i></td>
                </tr>
                <tr>
                  <td class="d-grid">
                    SEO
                    <p>www.example.com/seo</p>
                  </td>
                  <td>1 <i class="fa-solid fa-arrow-down"></i></td>
                </tr>
                <tr>
                  <td class="d-grid">
                    Contenido
                    <p>www.example.com/contenido</p>
                  </td>
                  <td>3 <i class="fa-solid fa-arrow-up"></i></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
